import { type Manifest, type RouterConfig, PAGE_TYPE } from '@/types/manifest.ts';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.PAGE,
    name: 'patent-drafting-v1',
    exclusiveRoutePath: '/patent-drafting-v1',
    getComponent: () => import('./PatentDraftingV1.vue'),
};

export const manifest: Manifest = {
    ...routerConfig,
};

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 去到 Patent Drafting V1 页面
         */
        executeCommand(commandId: 'command:route:patent-drafting-v1'): void;
    }
}
